import { render, staticRenderFns } from "./ShippingOverview.vue?vue&type=template&id=6cb66e61&"
import script from "./ShippingOverview.vue?vue&type=script&lang=js&"
export * from "./ShippingOverview.vue?vue&type=script&lang=js&"
import style0 from "./ShippingOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports